export default __webpack_public_path__ + "static/media/photo--sm--misc-3.23d5ba64.jpg";